import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"

export default class extends Controller {
  static values = { mode: { type: String, default: "date" }, format: { type: String, default: "Y-m-d" } }

  connect() {
    const options = { allowInput: true }

    if (this.modeValue === "time") {
      options.enableTime = true
      options.noCalendar = true
      options.dateFormat = "h:i K"
      options.time_24hr = false
    } else {
      options.dateFormat = this.formatValue
    }

    this._flatpickr = flatpickr(this.element, options)
  }

  disconnect() {
    if (this._flatpickr) {
      this._flatpickr.destroy()
    }
  }
}
